/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { UserAutocompleteDto } from './user-autocomplete.dto';

export const UserAutocompleteMapper = entity<UserAutocompleteDto>();
